// Search and filtering constants
export const SMALL_DATASET_THRESHOLD = 50
export const MEDIUM_DATASET_THRESHOLD = 1000
export const MAX_VISIBLE_OPTIONS = 200
export const MAX_INITIAL_OPTIONS = 100
export const MAX_SEARCH_SCOPE_STARTSWITH = 2000
export const MAX_SEARCH_SCOPE_INCLUDES = 1000
export const FIRST_CHAR_SEARCH_SCOPE = 500
export const SHORT_INPUT_THRESHOLD = 2
export const MEDIUM_INPUT_THRESHOLD = 5
export const SHORT_DEBOUNCE_TIME = 50
export const STANDARD_DEBOUNCE_TIME = 150
